// extracted by mini-css-extract-plugin
export var active = "_a8-7";
export var container = "_a8-0";
export var evenWidth = "_a8-4";
export var large = "_a8-5";
export var outlet = "_a8-8";
export var slide = "_a8-2";
export var small = "_a8-6";
export var tab = "_a8-3";
export var tabs = "_a8-1";